module.exports = __webpack_public_path__ + "static/img/dummy1.4b533ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy1.png
// module id = 2/X9
// module chunks = 1